export default {
	'button.saveDraft': 'Guardar como borrador',
	'button.save': 'Guardar + Ruta',
	'translation.work': 'Trabajo',
	'translation.assignments': 'Asignaciones',
	'translation.new_assignment': 'Nueva Asignación',
	'translation.projects': 'Proyectos',
	'translation.contact_manager': 'Gerente de contacto',
	'translation.work_upload_tm': 'WorkUpload™',
	'translation.realtime': 'Tiempo real',
	'translation.talent': 'Talento',
	'translation.my_talent': 'Mi talento',
	'translation.find_talent': 'Buscar talentos',
	'translation.recruiting': 'Reclutamiento',
	'translation.tests': 'Pruebas',
	'translation.surveys': 'Encuestas',
	'translation.payments': 'Pagos',
	'translation.overview': 'Descripción general',
	'translation.invoices': 'Facturas',
	'translation.requests': 'Peticiones',
	'translation.funds': 'Fondos',
	'translation.add_funds': 'Añadir fondos',
	'translation.accounts': 'Cuentas',
	'translation.reports': 'Informes',
	'translation.dashboard': 'Cuadro de instrumentos',
	'translation.new_report': 'Nuevo Informe',
	'translation.all_reports': 'Todos los informes',
	'translation.analytics_dashboards': 'Cuadros de mando',
	'translation.custom_reports': 'Informes',
	'translation.talent_profile': 'Perfil de Talento',
	'translation.my_profile': 'Mi perfil',
	'translation.talent_pools': 'Piscinas de talento',
	'translation.my_work': 'Mi Trabajo',
	'translation.find_work': 'Buscar trabajo',
	'translation.search': 'Buscar',
	'translation.search_my_assignments': 'Buscar mis asignaciones',
	'translation.calendar': 'Calendario',
	'translation.ratings': 'Calificaciones',
	'translation.invitations': 'Usted tiene {0} invitaciones pendientes de la piscina del talento',
	'translation.view_invitations': 'Ver invitaciones',
	'translation.analytics': 'Analítica',
	'translation.talent_profile_op': 'Cuenta',
	'translation.my_profile_op': 'Perfil',
	'translation.tax_info': 'Información Fiscal',
	'translation.home': 'Hogar',
	'translation.orgstructure':'Estructura organizacional',
	'translation.withholding_orders':'Órdenes de retención'
};
